module.exports = __webpack_public_path__ + "static/21-775bdbd4baf89ba4dcea5b7d57864b16.jpeg";